/**
 * @deprecated
 * To be removed in favor of union type "IconName" below (#3258)
 */
export const enum Icon {
  AccidentManagementXs = 'accident-management-xs',
  AccidentManagement = 'accident-management',
  AddOpt = 'add-opt',
  AlertCircle = 'alert-circle',
  Alert = 'alert',
  ArchiveXs = 'archive-xs',
  Archive = 'archive',
  ArrowBack = 'arrow-back',
  ArrowDownLeft_24 = 'arrow-down-left/24',
  ArrowDownRight_24 = 'arrow-down-right/24',
  ArrowDown = 'arrow-down',
  ArrowForward = 'arrow-forward',
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  ArrowUpLeft_24 = 'arrow-up-left/24',
  ArrowUpRight_24 = 'arrow-up-right/24',
  ArrowUp = 'arrow-up',
  AttachDriver = 'attach-driver',
  Attention = 'attention',
  Authentication = 'authentication',
  BadgeEco = 'badge-eco',
  BadgeSafety = 'badge-safety',
  Baht_24 = 'baht/24',
  BahtSymbol_24 = 'baht-symbol/24',
  Battery = 'battery',
  Bds15mDistance_16 = 'bds/1-5m-distance/16',
  Bds15mDistance_24 = 'bds/1-5m-distance/24',
  BdsAccelerator_24 = 'bds/accelerator/24',
  BdsAccessibility_24 = 'bds/accessibility/24',
  BdsAccidentCare_24 = 'bds/accident-care/24',
  BdsAccidentManagement_24 = 'bds/accident-management/24',
  BdsAi_12 = 'bds/ai/12',
  BdsAi_16 = 'bds/ai/16',
  BdsAi_24 = 'bds/ai/24',
  BdsAi_32 = 'bds/ai/32',
  BdsArrowBack_16 = 'bds/arrow-back/16',
  BdsArrowBack_24 = 'bds/arrow-back/24',
  BdsArrowDown_16 = 'bds/arrow-down/16',
  BdsArrowDown_24 = 'bds/arrow-down/24',
  BdsArrowDownload_16 = 'bds/arrow-download/16',
  BdsArrowDownload_24 = 'bds/arrow-download/24',
  BdsArrowForward_16 = 'bds/arrow-forward/16',
  BdsArrowForward_24 = 'bds/arrow-forward/24',
  BdsArrowLeft_24 = 'bds/arrow-left/24',
  BdsArrowRight_24 = 'bds/arrow-right/24',
  BdsArrowUp_16 = 'bds/arrow-up/16',
  BdsArrowUp_24 = 'bds/arrow-up/24',
  BdsBackwardEnd_24 = 'bds/backward-end/24',
  BdsBackwardEnd2_24 = 'bds/backward-end-2/24',
  BdsBadgeCheckmark_24 = 'bds/badge-checkmark/24',
  BdsBadgeEco_24 = 'bds/badge-eco/24',
  BdsBattery_24 = 'bds/battery/24',
  BdsBatteryCapacity_24 = 'bds/battery-capacity/24',
  BdsBatteryCharging_24 = 'bds/battery-charging/24',
  BdsBatteryFillHigh_24 = 'bds/battery-fill-high/24',
  BdsBatteryFillLow_24 = 'bds/battery-fill-low/24',
  BdsBatteryHybrid_24 = 'bds/battery-hybrid/24',
  BdsBatteryManagement_24 = 'bds/battery-management/24',
  BdsBookmark_16 = 'bds/bookmark/16',
  BdsBookmark_24 = 'bds/bookmark/24',
  BdsBreakingFluid_24 = 'bds/breaking-fluid/24',
  BdsBreakingPad_24 = 'bds/breaking-pad/24',
  BdsBufferLoader_16 = 'bds/buffer-loader/16',
  BdsBufferLoader_24 = 'bds/buffer-loader/24',
  BdsBuildUpDepth1_24 = 'bds/build-up-depth-1/24',
  BdsBuildUpDepth2_24 = 'bds/build-up-depth-2/24',
  BdsBuildUpHeight1_24 = 'bds/build-up-height-1/24',
  BdsBuildUpHeight2_24 = 'bds/build-up-height-2/24',
  BdsBuildUpWeight1_24 = 'bds/build-up-weight-1/24',
  BdsBuildUpWeight2_24 = 'bds/build-up-weight-2/24',
  BdsBuildUpWidth1_24 = 'bds/build-up-width-1/24',
  BdsBuildUpWidth2_24 = 'bds/build-up-width-2/24',
  BdsBusinessCase_24 = 'bds/business-case/24',
  BdsCalculator_16 = 'bds/calculator/16',
  BdsCalculator_24 = 'bds/calculator/24',
  BdsCalendar_24 = 'bds/calendar/24',
  BdsCall_24 = 'bds/call/24',
  BdsCallSos_24 = 'bds/call-sos/24',
  BdsCamera_24 = 'bds/camera/24',
  BdsCar_16 = 'bds/car/16',
  BdsCar_24 = 'bds/car/24',
  BdsCarCompare_24 = 'bds/car-compare/24',
  BdsCarConfig_16 = 'bds/car-config/16',
  BdsCarConfig_24 = 'bds/car-config/24',
  BdsCarExchange_24 = 'bds/car-exchange/24',
  BdsCarFinder_24 = 'bds/car-finder/24',
  BdsCarNew_16 = 'bds/car-new/16',
  BdsCarNew_24 = 'bds/car-new/24',
  BdsCarOpenTop_24 = 'bds/car-open-top/24',
  BdsCarSave_24 = 'bds/car-save/24',
  BdsCaretDown_16 = 'bds/caret-down/16',
  BdsCaretDown_24 = 'bds/caret-down/24',
  BdsCaretUpDown_16 = 'bds/caret-up-down/16',
  BdsCaretUpDown_24 = 'bds/caret-up-down/24',
  BdsCenter_24 = 'bds/center/24',
  BdsCharging_24 = 'bds/charging/24',
  BdsChargingAc_24 = 'bds/charging-ac/24',
  BdsChargingDc_24 = 'bds/charging-dc/24',
  BdsChargingTime_24 = 'bds/charging-time/24',
  BdsChat_16 = 'bds/chat/16',
  BdsChat_24 = 'bds/chat/24',
  BdsCheckmark_16 = 'bds/checkmark/16',
  BdsCheckmark_24 = 'bds/checkmark/24',
  BdsCheckmarkCircle_16 = 'bds/checkmark-circle/16',
  BdsCheckmarkCircle_24 = 'bds/checkmark-circle/24',
  BdsChevronDown_16 = 'bds/chevron-down/16',
  BdsChevronDown_24 = 'bds/chevron-down/24',
  BdsChevronHorizontal_24 = 'bds/chevron-horizontal/24',
  BdsChevronLeft_16 = 'bds/chevron-left/16',
  BdsChevronLeft_24 = 'bds/chevron-left/24',
  BdsChevronRight_16 = 'bds/chevron-right/16',
  BdsChevronRight_24 = 'bds/chevron-right/24',
  BdsChevronUp_16 = 'bds/chevron-up/16',
  BdsChevronUp_24 = 'bds/chevron-up/24',
  BdsClose_16 = 'bds/close/16',
  BdsClose_24 = 'bds/close/24',
  BdsColumnView3_16 = 'bds/column-view-3/16',
  BdsColumnView3_24 = 'bds/column-view-3/24',
  BdsCompass_24 = 'bds/compass/24',
  BdsContent_16 = 'bds/content/16',
  BdsContent_24 = 'bds/content/24',
  BdsCoolingFluid_16 = 'bds/cooling-fluid/16',
  BdsCoolingFluid_24 = 'bds/cooling-fluid/24',
  BdsDisc_16 = 'bds/disc/16',
  BdsDisc_24 = 'bds/disc/24',
  BdsDiscount_24 = 'bds/discount/24',
  BdsDocument_24 = 'bds/document/24',
  BdsDownload_16 = 'bds/download/16',
  BdsDownload_24 = 'bds/download/24',
  BdsDownloadPrint_24 = 'bds/download-print/24',
  BdsDriveType_24 = 'bds/drive-type/24',
  BdsDriveTypeAllWheel_24 = 'bds/drive-type-all-wheel/24',
  BdsDriveTypeFrontWheel_24 = 'bds/drive-type-front-wheel/24',
  BdsDriveTypeRearWheel_24 = 'bds/drive-type-rear-wheel/24',
  BdsECar_24 = 'bds/e-car/24',
  BdsECarComp_24 = 'bds/e-car-comp/24',
  BdsEcoCoach_24 = 'bds/eco-coach/24',
  BdsEcoConsumption_24 = 'bds/eco-consumption/24',
  BdsElectricConsumption_24 = 'bds/electric-consumption/24',
  BdsEngine_16 = 'bds/engine/16',
  BdsEngine_24 = 'bds/engine/24',
  BdsEquipmentLine_24 = 'bds/equipment-line/24',
  BdsExclamationMark_16 = 'bds/exclamation-mark/16',
  BdsExclamationMark_24 = 'bds/exclamation-mark/24',
  BdsExclamationMarkCircleOutline_16 = 'bds/exclamation-mark-circle-outline/16',
  BdsExclamationMarkCircleOutline_24 = 'bds/exclamation-mark-circle-outline/24',
  BdsEye_16 = 'bds/eye/16',
  BdsEye_24 = 'bds/eye/24',
  BdsFacebook_24 = 'bds/facebook/24',
  BdsFilter_24 = 'bds/filter/24',
  BdsFinger_24 = 'bds/finger/24',
  BdsForwardEnd_24 = 'bds/forward-end/24',
  BdsForwardEnd2_24 = 'bds/forward-end-2/24',
  BdsFuel_24 = 'bds/fuel/24',
  BdsFuelComp_24 = 'bds/fuel-comp/24',
  BdsFuelE_24 = 'bds/fuel-e/24',
  BdsFuelEComp_24 = 'bds/fuel-e-comp/24',
  BdsFullscreen_16 = 'bds/fullscreen/16',
  BdsFullscreen_24 = 'bds/fullscreen/24',
  BdsFullscreenExit_16 = 'bds/fullscreen-exit/16',
  BdsFullscreenExit_24 = 'bds/fullscreen-exit/24',
  BdsGear_16 = 'bds/gear/16',
  BdsGear_24 = 'bds/gear/24',
  BdsGeofenceCircle_16 = 'bds/geofence-circle/16',
  BdsGeofenceCircle_24 = 'bds/geofence-circle/24',
  BdsGeofenceRectangle_16 = 'bds/geofence-rectangle/16',
  BdsGeofenceRectangle_24 = 'bds/geofence-rectangle/24',
  BdsGeofenceTriangle_16 = 'bds/geofence-triangle/16',
  BdsGeofenceTriangle_24 = 'bds/geofence-triangle/24',
  BdsGlobe_16 = 'bds/globe/16',
  BdsGlobe_24 = 'bds/globe/24',
  BdsGraph_24 = 'bds/graph/24',
  BdsGridView16_16 = 'bds/grid-view-16/16',
  BdsGridView16_24 = 'bds/grid-view-16/24',
  BdsGridView4_16 = 'bds/grid-view-4/16',
  BdsGridView4_24 = 'bds/grid-view-4/24',
  BdsGridView9_16 = 'bds/grid-view-9/16',
  BdsGridView9_24 = 'bds/grid-view-9/24',
  BdsHome_16 = 'bds/home/16',
  BdsHome_24 = 'bds/home/24',
  BdsHotspotActive_16 = 'bds/hotspot-active/16',
  BdsHotspotActive_24 = 'bds/hotspot-active/24',
  BdsHotspotDefault_16 = 'bds/hotspot-default/16',
  BdsHotspotDefault_24 = 'bds/hotspot-default/24',
  BdsImage_16 = 'bds/image/16',
  BdsImage_24 = 'bds/image/24',
  BdsInductionCharging_24 = 'bds/induction-charging/24',
  BdsInfo_16 = 'bds/info/16',
  BdsInfo_24 = 'bds/info/24',
  BdsInfoCircle_16 = 'bds/info-circle/16',
  BdsInfoCircle_24 = 'bds/info-circle/24',
  BdsInfoFile_24 = 'bds/info-file/24',
  BdsInspectionHu_24 = 'bds/inspection-hu/24',
  BdsInstagram_24 = 'bds/instagram/24',
  BdsInsurance_24 = 'bds/insurance/24',
  BdsInternetInVan_24 = 'bds/internet-in-van/24',
  BdsLayers_16 = 'bds/layers/16',
  BdsLayers_24 = 'bds/layers/24',
  BdsLight_24 = 'bds/light/24',
  BdsLightOff_24 = 'bds/light-off/24',
  BdsLightOn_24 = 'bds/light-on/24',
  BdsLink_16 = 'bds/link/16',
  BdsLink_24 = 'bds/link/24',
  BdsLinkedin_24 = 'bds/linkedin/24',
  BdsListView_16 = 'bds/list-view/16',
  BdsListView_24 = 'bds/list-view/24',
  BdsLiveTrafficCar_24 = 'bds/live-traffic-car/24',
  BdsLiveTrafficVan_24 = 'bds/live-traffic-van/24',
  BdsLocation_16 = 'bds/location/16',
  BdsLocation_24 = 'bds/location/24',
  BdsLocationDealer_16 = 'bds/location-dealer/16',
  BdsLocationDealer_24 = 'bds/location-dealer/24',
  BdsLocationDestination_16 = 'bds/location-destination/16',
  BdsLocationDestination_24 = 'bds/location-destination/24',
  BdsLocationFavorite_16 = 'bds/location-favorite/16',
  BdsLocationFavorite_24 = 'bds/location-favorite/24',
  BdsLocationPin_16 = 'bds/location-pin/16',
  BdsLocationPin_24 = 'bds/location-pin/24',
  BdsLockClosed_16 = 'bds/lock-closed/16',
  BdsLockClosed_24 = 'bds/lock-closed/24',
  BdsLockOpen_16 = 'bds/lock-open/16',
  BdsLockOpen_24 = 'bds/lock-open/24',
  BdsLogin_16 = 'bds/login/16',
  BdsLogin_24 = 'bds/login/24',
  BdsLogistics_24 = 'bds/logistics/24',
  BdsLogout_16 = 'bds/logout/16',
  BdsLogout_24 = 'bds/logout/24',
  BdsMail_16 = 'bds/mail/16',
  BdsMail_24 = 'bds/mail/24',
  BdsMap_24 = 'bds/map/24',
  BdsMapRefresh_24 = 'bds/map-refresh/24',
  BdsMbStar_16 = 'bds/mb-star/16',
  BdsMbStar_24 = 'bds/mb-star/24',
  BdsMediaPlay_16 = 'bds/media-play/16',
  BdsMediaPlay_24 = 'bds/media-play/24',
  BdsMenu_16 = 'bds/menu/16',
  BdsMenu_24 = 'bds/menu/24',
  BdsMessage_16 = 'bds/message/16',
  BdsMessage_24 = 'bds/message/24',
  BdsMileage_24 = 'bds/mileage/24',
  BdsMinus_16 = 'bds/minus/16',
  BdsMinus_24 = 'bds/minus/24',
  BdsMobileView360_24 = 'bds/mobile-view-360/24',
  BdsMonitorDriveStyle_24 = 'bds/monitor-drive-style/24',
  BdsMonitorEco_24 = 'bds/monitor-eco/24',
  BdsMonitorStatistics_24 = 'bds/monitor-statistics/24',
  BdsMore_16 = 'bds/more/16',
  BdsMore_24 = 'bds/more/24',
  BdsMusic_24 = 'bds/music/24',
  BdsNavigationFleet_24 = 'bds/navigation-fleet/24',
  BdsNoCamera_24 = 'bds/no-camera/24',
  BdsNoEye_16 = 'bds/no-eye/16',
  BdsNoEye_24 = 'bds/no-eye/24',
  BdsNotification_16 = 'bds/notification/16',
  BdsNotification_24 = 'bds/notification/24',
  BdsOil_24 = 'bds/oil/24',
  BdsOpenNew_16 = 'bds/open-new/16',
  BdsOpenNew_24 = 'bds/open-new/24',
  BdsPassengerTransport_24 = 'bds/passenger-transport/24',
  BdsPause_24 = 'bds/pause/24',
  BdsPencil_16 = 'bds/pencil/16',
  BdsPencil_24 = 'bds/pencil/24',
  BdsPencilCompany_24 = 'bds/pencil-company/24',
  BdsPencilDocument_24 = 'bds/pencil-document/24',
  BdsPhone_24 = 'bds/phone/24',
  BdsPinch_24 = 'bds/pinch/24',
  BdsPlus_16 = 'bds/plus/16',
  BdsPlus_24 = 'bds/plus/24',
  BdsPriceDollar_24 = 'bds/price-dollar/24',
  BdsPriceEuro_24 = 'bds/price-euro/24',
  BdsPrint_16 = 'bds/print/16',
  BdsPrint_24 = 'bds/print/24',
  BdsQuestionMark_16 = 'bds/question-mark/16',
  BdsQuestionMark_24 = 'bds/question-mark/24',
  BdsQuestionMarkCircleOutline_24 = 'bds/question-mark-circle-outline/24',
  BdsRangeEletric_24 = 'bds/range-eletric/24',
  BdsRangeExtension_24 = 'bds/range-extension/24',
  BdsRefresh_16 = 'bds/refresh/16',
  BdsRefresh_24 = 'bds/refresh/24',
  BdsRemoteControl_24 = 'bds/remote-control/24',
  BdsReset_16 = 'bds/reset/16',
  BdsReset_24 = 'bds/reset/24',
  BdsReturnVehicle_24 = 'bds/return-vehicle/24',
  BdsRoad_24 = 'bds/road/24',
  BdsRotateLandscape_16 = 'bds/rotate-landscape/16',
  BdsRotateLandscape_24 = 'bds/rotate-landscape/24',
  BdsRotatePortrait_16 = 'bds/rotate-portrait/16',
  BdsRotatePortrait_24 = 'bds/rotate-portrait/24',
  BdsRoute_24 = 'bds/route/24',
  BdsRouteOverviewSettings_24 = 'bds/route-overview-settings/24',
  BdsSafetyLock_24 = 'bds/safety-lock/24',
  BdsSearch_16 = 'bds/search/16',
  BdsSearch_24 = 'bds/search/24',
  BdsSeat_24 = 'bds/seat/24',
  BdsSeatFront_24 = 'bds/seat-front/24',
  BdsSeatSections_24 = 'bds/seat-sections/24',
  BdsService_16 = 'bds/service/16',
  BdsService_24 = 'bds/service/24',
  BdsServiceA_24 = 'bds/service-a/24',
  BdsServiceB_24 = 'bds/service-b/24',
  BdsServiceCalendar_24 = 'bds/service-calendar/24',
  BdsServiceCraft_24 = 'bds/service-craft/24',
  BdsServiceLocal_24 = 'bds/service-local/24',
  BdsShoppingCart_16 = 'bds/shopping-cart/16',
  BdsShoppingCart_24 = 'bds/shopping-cart/24',
  BdsShoppingCartSearch_24 = 'bds/shopping-cart-search/24',
  BdsSnowflake_16 = 'bds/snowflake/16',
  BdsSnowflake_24 = 'bds/snowflake/24',
  BdsSpecialOffer_24 = 'bds/special-offer/24',
  BdsStar_16 = 'bds/star/16',
  BdsStar_24 = 'bds/star/24',
  BdsStatistics_24 = 'bds/statistics/24',
  BdsStop_24 = 'bds/stop/24',
  BdsSubsidy_24 = 'bds/subsidy/24',
  BdsSwitchSeat_24 = 'bds/switch-seat/24',
  BdsTestDrive_24 = 'bds/test-drive/24',
  BdsTime_16 = 'bds/time/16',
  BdsTime_24 = 'bds/time/24',
  BdsTimePlus_24 = 'bds/time-plus/24',
  BdsTirePressure_24 = 'bds/tire-pressure/24',
  BdsTotalWeight_24 = 'bds/total-weight/24',
  BdsTowTruck_24 = 'bds/tow-truck/24',
  BdsTransmission_24 = 'bds/transmission/24',
  BdsTrash_16 = 'bds/trash/16',
  BdsTrash_24 = 'bds/trash/24',
  BdsTwitter_24 = 'bds/twitter/24',
  BdsTwoFinger_24 = 'bds/two-finger/24',
  BdsUpload_24 = 'bds/upload/24',
  BdsUser_16 = 'bds/user/16',
  BdsUser_24 = 'bds/user/24',
  BdsUserGroup_24 = 'bds/user-group/24',
  BdsUserMinus_24 = 'bds/user-minus/24',
  BdsUserPlus_24 = 'bds/user-plus/24',
  BdsUserProfile_16 = 'bds/user-profile/16',
  BdsUserProfile_24 = 'bds/user-profile/24',
  BdsUserProfileSelection_24 = 'bds/user-profile-selection/24',
  BdsVan_24 = 'bds/van/24',
  BdsVanCabinType1_24 = 'bds/van-cabin-type-1/24',
  BdsVanCabinType2_24 = 'bds/van-cabin-type-2/24',
  BdsVanChecked_24 = 'bds/van-checked/24',
  BdsVanCitanMixto_24 = 'bds/van-citan-mixto/24',
  BdsVanCitanPanel_24 = 'bds/van-citan-panel/24',
  BdsVanCitanTourer_24 = 'bds/van-citan-tourer/24',
  BdsVanCompare_24 = 'bds/van-compare/24',
  BdsVanConfiguration_24 = 'bds/van-configuration/24',
  BdsVanDriveMode1_24 = 'bds/van-drive-mode-1/24',
  BdsVanDriveMode2_24 = 'bds/van-drive-mode-2/24',
  BdsVanDropside_24 = 'bds/van-dropside/24',
  BdsVanDropsideCrewcabin_24 = 'bds/van-dropside-crewcabin/24',
  BdsVanElectric_24 = 'bds/van-electric/24',
  BdsVanExchange_24 = 'bds/van-exchange/24',
  BdsVanFrontal_24 = 'bds/van-frontal/24',
  BdsVanMarcoPolo_24 = 'bds/van-marco-polo/24',
  BdsVanMarcoPoloEasyUp_24 = 'bds/van-marco-polo-easy-up/24',
  BdsVanModel_24 = 'bds/van-model/24',
  BdsVanOpenTop_24 = 'bds/van-open-top/24',
  BdsVanPickup_24 = 'bds/van-pickup/24',
  BdsVanRental_24 = 'bds/van-rental/24',
  BdsVanRoofType_24 = 'bds/van-roof-type/24',
  BdsVanSectorCarpenter_24 = 'bds/van-sector-carpenter/24',
  BdsVanSectorFood_24 = 'bds/van-sector-food/24',
  BdsVanSectorGlazier_24 = 'bds/van-sector-glazier/24',
  BdsVanSectorLandscape_24 = 'bds/van-sector-landscape/24',
  BdsVanSectorPainter_24 = 'bds/van-sector-painter/24',
  BdsVanSectorPlumbing_24 = 'bds/van-sector-plumbing/24',
  BdsVanShare_24 = 'bds/van-share/24',
  BdsVanSprinter_24 = 'bds/van-sprinter/24',
  BdsVanSprinterChassis_24 = 'bds/van-sprinter-chassis/24',
  BdsVanSprinterChassisCrewcabine_24 = 'bds/van-sprinter-chassis-crewcabine/24',
  BdsVanSprinterChassisOption_24 = 'bds/van-sprinter-chassis-option/24',
  BdsVanSprinterMixto_24 = 'bds/van-sprinter-mixto/24',
  BdsVanSprinterPanel_24 = 'bds/van-sprinter-panel/24',
  BdsVanToggleBuildUp1_24 = 'bds/van-toggle-build-up-1/24',
  BdsVanToggleBuildUp2_24 = 'bds/van-toggle-build-up-2/24',
  BdsVanToggleBuildUp3_24 = 'bds/van-toggle-build-up-3/24',
  BdsVanToggleBuildUp4_24 = 'bds/van-toggle-build-up-4/24',
  BdsVanToggleBuildUp5_24 = 'bds/van-toggle-build-up-5/24',
  BdsVanToggleBuildUp7_24 = 'bds/van-toggle-build-up-7/24',
  BdsVanTransport_24 = 'bds/van-transport/24',
  BdsVanTravel_24 = 'bds/van-travel/24',
  BdsVanUptime_24 = 'bds/van-uptime/24',
  BdsVanVehicleSearch_24 = 'bds/van-vehicle-search/24',
  BdsVanVitoMixto_24 = 'bds/van-vito-mixto/24',
  BdsVanVitoPanel_24 = 'bds/van-vito-panel/24',
  BdsVanVitoTourer_24 = 'bds/van-vito-tourer/24',
  BdsVanWheelbase1_24 = 'bds/van-wheelbase-1/24',
  BdsVanWheelbase2_24 = 'bds/van-wheelbase-2/24',
  BdsVehicleSearch_24 = 'bds/vehicle-search/24',
  BdsView360_16 = 'bds/view-360/16',
  BdsView360_24 = 'bds/view-360/24',
  BdsVolumeDown_16 = 'bds/volume-down/16',
  BdsVolumeDown_24 = 'bds/volume-down/24',
  BdsVolumeOff_16 = 'bds/volume-off/16',
  BdsVolumeOff_24 = 'bds/volume-off/24',
  BdsVolumeUp_16 = 'bds/volume-up/16',
  BdsVolumeUp_24 = 'bds/volume-up/24',
  BdsWallBox_24 = 'bds/wall-box/24',
  BdsWarning_16 = 'bds/warning/16',
  BdsWarning_24 = 'bds/warning/24',
  BdsWasherFluid_24 = 'bds/washer-fluid/24',
  BdsWheel_24 = 'bds/wheel/24',
  BdsWheelbarrow_24 = 'bds/wheelbarrow/24',
  BdsWheelchair_24 = 'bds/wheelchair/24',
  BdsWifi_16 = 'bds/wifi/16',
  BdsWifi_24 = 'bds/wifi/24',
  BdsWishlist_24 = 'bds/wishlist/24',
  BdsWishlistOutlined_24 = 'bds/wishlist-outlined/24',
  BdsYoutube_24 = 'bds/youtube/24',
  BdsZoomIn_16 = 'bds/zoom-in/16',
  BdsZoomIn_24 = 'bds/zoom-in/24',
  BdsZoomOut_16 = 'bds/zoom-out/16',
  BdsZoomOut_24 = 'bds/zoom-out/24',
  BookmarkXs = 'bookmark-xs',
  Bookmark = 'bookmark',
  BreakdownManagementXs = 'breakdown-management-xs',
  BreakdownManagement = 'breakdown-management',
  BreakingFluid = 'breaking-fluid',
  BreakingPad = 'breaking-pad',
  BrochuresXs = 'brochures-xs',
  Brochures = 'brochures',
  BufferLoader = 'buffer-loader',
  BuildUpDepth1 = 'build-up-depth-1',
  BuildUpDepth2 = 'build-up-depth-2',
  BuildUpHeight1 = 'build-up-height-1',
  BuildUpHeight2 = 'build-up-height-2',
  BuildUpWeight1 = 'build-up-weight-1',
  BuildUpWeight2 = 'build-up-weight-2',
  BuildUpWidth1 = 'build-up-width-1',
  BuildUpWidth2 = 'build-up-width-2',
  Bus = 'bus',
  Calculator = 'calculator',
  Calendar = 'calendar',
  CalenderXs = 'calender-xs',
  CallSos = 'call-sos',
  Call = 'call',
  Camera = 'camera',
  CarCompareXs = 'car-compare-xs',
  CarCompare = 'car-compare',
  CarConfig = 'car-config',
  CarExchange = 'car-exchange',
  CarNew = 'car-new',
  CarOpentopXs = 'car-opentop-xs',
  CarOpentop = 'car-opentop',
  CarSaveXs = 'car-save-xs',
  CarSave = 'car-save',
  CarToX = 'car-to-x',
  CarXs = 'car-xs',
  Car = 'car',
  CaretDown = 'caret-down',
  CaretDown_16 = 'caret-down/16',
  CaretDown_24 = 'caret-down/24',
  CaretUp_16 = 'caret-up/16',
  CaretUp_24 = 'caret-up/24',
  CaretUpAndDown = 'caret-up-and-down',
  CaretUpAndDown_16 = 'caret-up-and-down/16',
  CaretUpAndDown_24 = 'caret-up-and-down/24',
  Center = 'center',
  CepLogistics = 'cep-logistics',
  ChangeVehicle = 'change-vehicle',
  ChatXs = 'chat-xs',
  Chat = 'chat',
  CheckmarkCircle = 'checkmark-circle',
  CheckmarkXs = 'checkmark-xs',
  Checkmark = 'checkmark',
  ChevronDown = 'chevron-down',
  ChevronDown_16 = 'chevron-down/16',
  ChevronDown_24 = 'chevron-down/24',
  ChevronLeft = 'chevron-left',
  ChevronLeft_16 = 'chevron-left/16',
  ChevronLeft_24 = 'chevron-left/24',
  ChevronRight = 'chevron-right',
  ChevronRight_16 = 'chevron-right/16',
  ChevronRight_24 = 'chevron-right/24',
  ChevronUp = 'chevron-up',
  ChevronUp_16 = 'chevron-up/16',
  ChevronUp_24 = 'chevron-up/24',
  ChooseVehicle = 'choose-vehicle',
  Close = 'close',
  Close_16 = 'close/16',
  Close_24 = 'close/24',
  Co2LabelA = 'co2-label-a',
  Co2LabelAplus = 'co2-label-aplus',
  Co2LabelB = 'co2-label-b',
  Co2LabelC = 'co2-label-c',
  Co2LabelD = 'co2-label-d',
  Co2LabelE = 'co2-label-e',
  Co2LabelF = 'co2-label-f',
  Co2LabelG = 'co2-label-g',
  CommentXs = 'comment-xs',
  Comment = 'comment',
  Company_24 = 'company/24',
  CompanyRegistration = 'company-registration',
  Compass = 'compass',
  Connected = 'connected',
  ConstructionIndustry = 'construction-industry',
  Consumption = 'consumption',
  ContactXs = 'contact-xs',
  Contact = 'contact',
  Content = 'content',
  Convertible = 'convertible',
  CoolingFluid = 'cooling-fluid',
  CopyClipboard_24 = 'copy-clipboard/24',
  Copy = 'copy',
  Coupe = 'coupe',
  CreditCard_16 = 'credit-card/16',
  CreditCard_24 = 'credit-card/24',
  DanishKrone_24 = 'danish-krone/24',
  DataInterface1 = 'data-interface-1',
  DataInterface2 = 'data-interface-2',
  DataInterface = 'data-interface',
  Dealer = 'dealer',
  Delete = 'delete',
  DettachDriver = 'dettach-driver',
  DigitalRecords1 = 'digital-records-1',
  DigitalRecords2 = 'digital-records-2',
  DollarSymbol_24 = 'dollar-symbol/24',
  Download = 'download',
  DownloadprintXs = 'downloadprint-xs',
  Downloadprint = 'downloadprint',
  DriveStyleMonitor = 'drive-style-monitor',
  DriveTypeAllWheel = 'drive-type-all-wheel',
  DriveTypeFrontWheel = 'drive-type-front-wheel',
  DriveTypeRearWheel = 'drive-type-rear-wheel',
  DriveType = 'drive-type',
  DrivingStyleAnalysis1 = 'driving-style-analysis-1',
  DrivingStyleAnalysis2 = 'driving-style-analysis-2',
  EcoCoach = 'eco-coach',
  EcoMonitor = 'eco-monitor',
  EditDocument = 'edit-document',
  EditXs = 'edit-xs',
  Edit = 'edit',
  EngineXs = 'engine-xs',
  Engine = 'engine',
  EquipmentXs = 'equipment-xs',
  Equipment = 'equipment',
  EquipmentlineXs = 'equipmentline-xs',
  Equipmentline = 'equipmentline',
  Euro = 'euro',
  ExtendRuntime = 'extend-runtime',
  Eye = 'eye',
  Facebook = 'facebook',
  Favorite = 'favorite',
  Filter = 'filter',
  Finger = 'finger',
  FleetCommunication1 = 'fleet-communication-1',
  FleetCommunication2 = 'fleet-communication-2',
  FleetManagement1 = 'fleet-management-1',
  FleetManagement2 = 'fleet-management-2',
  FuelBio_24 = 'fuel-bio/24',
  FuelComp = 'fuel-comp',
  FuelEComp = 'fuel-e-comp',
  FuelE = 'fuel-e',
  FuelHybrid_24 = 'fuel-hybrid/24',
  FuelHydrogen_24 = 'fuel-hydrogen/24',
  FuelXs = 'fuel-xs',
  Fuel = 'fuel',
  Galleryview1 = 'galleryview-1',
  Galleryview2 = 'galleryview-2',
  Galleryview3 = 'galleryview-3',
  Galleryview4 = 'galleryview-4',
  GearXs = 'gear-xs',
  Gear = 'gear',
  GeofenceCircle = 'geofence-circle',
  GeofencePolygon = 'geofence-polygon',
  GeofenceRectangle = 'geofence-rectangle',
  Google = 'google',
  Hatchback = 'hatchback',
  HomeXs = 'home-xs',
  Home = 'home',
  HotspotActive = 'hotspot-active',
  HotspotDefault = 'hotspot-default',
  ImprovedNavigation1 = 'improved-navigation-1',
  ImprovedNavigation2 = 'improved-navigation-2',
  InspectionHu = 'inspection-hu',
  Instagram = 'instagram',
  Insurance = 'insurance',
  InternetInCar = 'internet-in-car',
  Jobs = 'jobs',
  KnowledgeBank = 'knowledge-bank',
  Krona = 'krona',
  LanguageXs = 'language-xs',
  Language = 'language',
  Layers = 'layers',
  LightOff = 'light-off',
  LightOn = 'light-on',
  Light = 'light',
  LimitedMobility = 'limited-mobility',
  Linkedin = 'linkedin',
  ListviewXs = 'listview-xs',
  Listview = 'listview',
  LiveTraffic = 'live-traffic',
  LocateMe = 'locate-me',
  LocationXs = 'location-xs',
  Location = 'location',
  LockClosed = 'lock-closed',
  LockOpen = 'lock-open',
  LoginXs = 'login-xs',
  Login = 'login',
  LogoutXs = 'logout-xs',
  Logout = 'logout',
  MagnifierIn = 'magnifier-in',
  MagnifierOut = 'magnifier-out',
  MailOpen_16 = 'mail-open/16',
  MailOpen_24 = 'mail-open/24',
  MalaysianRinggit_24 = 'malaysian-ringgit/24',
  MapUpdate = 'map-update',
  Map = 'map',
  MbosAirCondition_12 = 'mbos/air-condition/12',
  MbosAirCondition_16 = 'mbos/air-condition/16',
  MbosAirCondition_24 = 'mbos/air-condition/24',
  MbosAirCondition_32 = 'mbos/air-condition/32',
  MbosAlarmBellCheck_24 = 'mbos/alarm-bell-check/24',
  MbosApi_24 = 'mbos/api/24',
  MbosApiOperation_24 = 'mbos/api-operation/24',
  MbosApplications_24 = 'mbos/applications/24',
  MbosBrowserPageHierarchy_24 = 'mbos/browser-page-hierarchy/24',
  MbosCloud_24 = 'mbos/cloud/24',
  MbosConnectorChademo_12 = 'mbos/connector-chademo/12',
  MbosConnectorChademo_16 = 'mbos/connector-chademo/16',
  MbosConnectorChademo_24 = 'mbos/connector-chademo/24',
  MbosConnectorChademo_32 = 'mbos/connector-chademo/32',
  MbosConnectorCssType1_12 = 'mbos/connector-css-type1/12',
  MbosConnectorCssType1_16 = 'mbos/connector-css-type1/16',
  MbosConnectorCssType1_24 = 'mbos/connector-css-type1/24',
  MbosConnectorCssType1_32 = 'mbos/connector-css-type1/32',
  MbosConnectorCssType2_12 = 'mbos/connector-css-type2/12',
  MbosConnectorCssType2_16 = 'mbos/connector-css-type2/16',
  MbosConnectorCssType2_24 = 'mbos/connector-css-type2/24',
  MbosConnectorCssType2_32 = 'mbos/connector-css-type2/32',
  MbosConnectorGbT_12 = 'mbos/connector-gb-t/12',
  MbosConnectorGbT_16 = 'mbos/connector-gb-t/16',
  MbosConnectorGbT_24 = 'mbos/connector-gb-t/24',
  MbosConnectorGbT_32 = 'mbos/connector-gb-t/32',
  MbosConnectorType1_12 = 'mbos/connector-type1/12',
  MbosConnectorType1_16 = 'mbos/connector-type1/16',
  MbosConnectorType1_24 = 'mbos/connector-type1/24',
  MbosConnectorType1_32 = 'mbos/connector-type1/32',
  MbosConnectorType2_12 = 'mbos/connector-type2/12',
  MbosConnectorType2_16 = 'mbos/connector-type2/16',
  MbosConnectorType2_24 = 'mbos/connector-type2/24',
  MbosConnectorType2_32 = 'mbos/connector-type2/32',
  MbosConnectorType3_12 = 'mbos/connector-type3/12',
  MbosConnectorType3_16 = 'mbos/connector-type3/16',
  MbosConnectorType3_24 = 'mbos/connector-type3/24',
  MbosConnectorType3_32 = 'mbos/connector-type3/32',
  MbosContainerRegistry_24 = 'mbos/container-registry/24',
  MbosCopy_24 = 'mbos/copy/24',
  MbosCreateInitialVersion_24 = 'mbos/create-initial-version/24',
  MbosDeviceCluster_24 = 'mbos/device-cluster/24',
  MbosFileCode_24 = 'mbos/file-code/24',
  MbosFileCodeDowload_24 = 'mbos/file-code-dowload/24',
  MbosFileCodeDownload_24 = 'mbos/file-code-download/24',
  MbosFlash_24 = 'mbos/flash/24',
  MbosFleets_24 = 'mbos/fleets/24',
  MbosHardDrive_24 = 'mbos/hard-drive/24',
  MbosHierarchy1_24 = 'mbos/hierarchy-1/24',
  MbosHierarchy2_24 = 'mbos/hierarchy-2/24',
  MbosHierarchy3_24 = 'mbos/hierarchy-3/24',
  MbosHomeCharging_12 = 'mbos/home-charging/12',
  MbosHomeCharging_16 = 'mbos/home-charging/16',
  MbosHomeCharging_24 = 'mbos/home-charging/24',
  MbosHomeCharging_32 = 'mbos/home-charging/32',
  MbosItemAdded_24 = 'mbos/item-added/24',
  MbosItemRemoved_24 = 'mbos/item-removed/24',
  MbosLaptop_24 = 'mbos/laptop/24',
  MbosMdxCli_24 = 'mbos/mdx-cli/24',
  MbosMicrochipBoard_24 = 'mbos/microchip-board/24',
  MbosNetworkSettings_24 = 'mbos/network-settings/24',
  MbosOfficeCharging_12 = 'mbos/office-charging/12',
  MbosOfficeCharging_16 = 'mbos/office-charging/16',
  MbosOfficeCharging_24 = 'mbos/office-charging/24',
  MbosOfficeCharging_32 = 'mbos/office-charging/32',
  MbosPackageCar_24 = 'mbos/package-car/24',
  MbosPackageDomain_24 = 'mbos/package-domain/24',
  MbosPackageEcu_24 = 'mbos/package-ecu/24',
  MbosPackageGeneric_24 = 'mbos/package-generic/24',
  MbosPackageRevision_24 = 'mbos/package-revision/24',
  MbosPackageSystem_24 = 'mbos/package-system/24',
  MbosPackageVariant_24 = 'mbos/package-variant/24',
  MbosPackages_24 = 'mbos/packages/24',
  MbosPermissionDenied_24 = 'mbos/permission-denied/24',
  MbosPlugAndChargeLogo_12 = 'mbos/plug-and-charge-logo/12',
  MbosPlugAndChargeLogo_16 = 'mbos/plug-and-charge-logo/16',
  MbosPlugAndChargeLogo_24 = 'mbos/plug-and-charge-logo/24',
  MbosPlugAndChargeLogo_32 = 'mbos/plug-and-charge-logo/32',
  MbosShipmentNext_24 = 'mbos/shipment-next/24',
  MbosShipmentOnlineMonitor_24 = 'mbos/shipment-online-monitor/24',
  MbosStatus_24 = 'mbos/status/24',
  MbosStatusSmall_24 = 'mbos/status-small/24',
  MbosTesting_24 = 'mbos/testing/24',
  MbosVariantCoding_24 = 'mbos/variant-coding/24',
  MbosVariantCodingTool_24 = 'mbos/variant-coding-tool/24',
  MediaBackXs = 'media-back-xs',
  MediaBack = 'media-back',
  MediaForwardXs = 'media-forward-xs',
  MediaForward = 'media-forward',
  MediaPauseXs = 'media-pause-xs',
  MediaPause = 'media-pause',
  MediaPlay_16 = 'media-play/16',
  MediaPlay_24 = 'media-play/24',
  MediaStop = 'media-stop',
  MediaToEndXs = 'media-to-end-xs',
  MediaToEnd = 'media-to-end',
  MediaToStartXs = 'media-to-start-xs',
  MediaToStart = 'media-to-start',
  MenuXs = 'menu-xs',
  Menu = 'menu',
  MercedesBenzMyvan = 'mercedes-benz-myvan',
  MileageDigital = 'mileage-digital',
  MileageXs = 'mileage-xs',
  Mileage = 'mileage',
  Minus = 'minus',
  Minus_16 = 'minus/16',
  Minus_24 = 'minus/24',
  MobileView360 = 'mobile-view-360',
  Modelfinder = 'modelfinder',
  Modeltype = 'modeltype',
  More = 'more',
  MultimediaNavigation = 'multimedia-navigation',
  MultiplyUserXs = 'multiply-user-xs',
  MultiplyUser = 'multiply-user',
  MusicXs = 'music-xs',
  Music = 'music',
  NavigationCoach = 'navigation-coach',
  NavigationFleet = 'navigation-fleet',
  NavigationMonitor = 'navigation-monitor',
  NoCamera = 'no-camera',
  NoEye = 'no-eye',
  Notification = 'notification',
  Offroader = 'offroader',
  Oil = 'oil',
  OptimizedAssistance1 = 'optimized-assistance-1',
  OptimizedAssistance2 = 'optimized-assistance-2',
  PassengerTransport = 'passenger-transport',
  Pause_16 = 'pause/16',
  Pause_24 = 'pause/24',
  Pencil_16 = 'pencil/16',
  Pencil_24 = 'pencil/24',
  PinGeneral = 'pin-general',
  Pinch = 'pinch',
  Pinterest = 'pinterest',
  Play = 'play',
  Plus = 'plus',
  PoiFavorite = 'poi-favorite',
  Pound = 'pound',
  PrintXs = 'print-xs',
  Print = 'print',
  Privacy = 'privacy',
  Productfinder = 'productfinder',
  QuestionMarkCircle = 'question-mark-circle',
  QuestionMarkOutline = 'question-mark-outline',
  Rand_24 = 'rand/24',
  Refrigerated = 'refrigerated',
  ReloadXs = 'reload-xs',
  Reload = 'reload',
  RemoteControl = 'remote-control',
  ResetZoom = 'reset-zoom',
  ReturnVehicle = 'return-vehicle',
  Roadster = 'roadster',
  RotateLandscape = 'rotate-landscape',
  RotatePortrait = 'rotate-portrait',
  Rupee_24 = 'rupee/24',
  RupeeSymbol_24 = 'rupee-symbol/24',
  RussianRuble1_24 = 'russian-ruble-1/24',
  RussianRuble2_24 = 'russian-ruble-2/24',
  RussianRubleSymbol_24 = 'russian-ruble-symbol/24',
  RussianRuble = 'russian-ruble',
  SafetyCoach = 'safety-coach',
  SafetyEvents = 'safety-events',
  SafetyTrophyEco = 'safety-trophy-eco',
  SafetyTrophy = 'safety-trophy',
  SaveXs = 'save-xs',
  Save = 'save',
  ScreenMax = 'screen-max',
  ScreenMin = 'screen-min',
  Scrollindicator = 'scrollindicator',
  SearchXs = 'search-xs',
  Search = 'search',
  SeatVan = 'seat-van',
  SeatXs = 'seat-xs',
  Seat = 'seat',
  Sedan = 'sedan',
  Send2car = 'send2car',
  ServiceA = 'service-a',
  ServiceAppointment = 'service-appointment',
  ServiceB = 'service-b',
  ServiceCar = 'service-car',
  ServiceCraft = 'service-craft',
  ServiceLocal = 'service-local',
  Service = 'service',
  Settings = 'settings',
  ShareXs = 'share-xs',
  Share = 'share',
  Shootingbrake = 'shootingbrake',
  ShoppingXs = 'shopping-xs',
  Shopping = 'shopping',
  Smart = 'smart',
  SoftwareUpdate = 'software-update',
  SoundMax = 'sound-max',
  SoundMin = 'sound-min',
  SoundOffXs = 'sound-off-xs',
  SoundOff = 'sound-off',
  Sportstourer = 'sportstourer',
  Statistics = 'statistics',
  SwedishKrona_24 = 'swedish-krona/24',
  SwissFranc_24 = 'swiss-franc/24',
  TModel = 't-model',
  Tag_16 = 'tag/16',
  Tag_24 = 'tag/24',
  TakeMeToVehicle = 'take-me-to-vehicle',
  TestdriveXs = 'testdrive-xs',
  Testdrive = 'testdrive',
  TheftWarning = 'theft-warning',
  TimeXs = 'time-xs',
  Time = 'time',
  TirePressure = 'tire-pressure',
  TrendDown = 'trend-down',
  TrendNeutral = 'trend-neutral',
  TrendUp = 'trend-up',
  TripBusiness = 'trip-business',
  TripEnd = 'trip-end',
  TripRouteDriverslog = 'trip-route-driverslog',
  TripRouteManagment = 'trip-route-managment',
  TripRoute = 'trip-route',
  TripStart = 'trip-start',
  TripType = 'trip-type',
  Truck = 'truck',
  TurkishLira_24 = 'turkish-lira/24',
  Twitter = 'twitter',
  TwoFinger = 'two-finger',
  Unimog = 'unimog',
  UploadXs = 'upload-xs',
  Upload = 'upload',
  UsedVehicleSearch = 'used-vehicle-search',
  User = 'user',
  Userimage = 'userimage',
  VanAdd = 'van-add',
  VanCabinType1 = 'van-cabin-type-1',
  VanCabinType2 = 'van-cabin-type-2',
  VanCitanMixto = 'van-citan-mixto',
  VanCitanPanel = 'van-citan-panel',
  VanCitanTourer = 'van-citan-tourer',
  VanCompare = 'van-compare',
  VanConfiguration = 'van-configuration',
  VanDriveMode1 = 'van-drive-mode-1',
  VanDriveMode2 = 'van-drive-mode-2',
  VanDropsideCrewcabine = 'van-dropside-crewcabine',
  VanDropside = 'van-dropside',
  VanFrontal = 'van-frontal',
  VanMaintenance = 'van-maintenance',
  VanMarcoPoloEasyUp = 'van-marco-polo-easy-up',
  VanMarcoPolo = 'van-marco-polo',
  VanModel = 'van-model',
  VanOpenTop = 'van-open-top',
  VanPickup = 'van-pickup',
  VanRental = 'van-rental',
  VanRoofType = 'van-roof-type',
  VanSprinterChassisCrewcabine = 'van-sprinter-chassis-crewcabine',
  VanSprinterChassisOptionDetail = 'van-sprinter-chassis-option-detail',
  VanSprinterChassisOption = 'van-sprinter-chassis-option',
  VanSprinterChassis = 'van-sprinter-chassis',
  VanSprinterMixto = 'van-sprinter-mixto',
  VanSprinterPanel = 'van-sprinter-panel',
  VanSprinter = 'van-sprinter',
  VanToggleBuildUp1 = 'van-toggle-build-up-1',
  VanToggleBuildUp2 = 'van-toggle-build-up-2',
  VanToggleBuildUp3 = 'van-toggle-build-up-3',
  VanToggleBuildUp4 = 'van-toggle-build-up-4',
  VanToggleBuildUp5 = 'van-toggle-build-up-5',
  VanToggleBuildUp6 = 'van-toggle-build-up-6',
  VanToggleBuildUp7 = 'van-toggle-build-up-7',
  VanToggleBuildUpXs1 = 'van-toggle-build-up-xs-1',
  VanToggleBuildUpXs2 = 'van-toggle-build-up-xs-2',
  VanToggleBuildUpXs3 = 'van-toggle-build-up-xs-3',
  VanToggleBuildUpXs4 = 'van-toggle-build-up-xs-4',
  VanToggleBuildUpXs5 = 'van-toggle-build-up-xs-5',
  VanToggleBuildUpXs6 = 'van-toggle-build-up-xs-6',
  VanTotalWeight = 'van-total-weight',
  VanTransport = 'van-transport',
  VanTravel = 'van-travel',
  VanVitoMixto = 'van-vito-mixto',
  VanVitoPanel = 'van-vito-panel',
  VanVitoTourer = 'van-vito-tourer',
  VanWheelbase1 = 'van-wheelbase-1',
  VanWheelbase2 = 'van-wheelbase-2',
  Van = 'van',
  Van2share = 'van2share',
  VehicleControl1 = 'vehicle-control-1',
  VehicleControl2 = 'vehicle-control-2',
  VehicleManagmentTool = 'vehicle-managment-tool',
  VehicleOperations = 'vehicle-operations',
  VehiclePanel = 'vehicle-panel',
  VehicleSupervision = 'vehicle-supervision',
  Vehiclesearch = 'vehiclesearch',
  VideoXs = 'video-xs',
  Video = 'video',
  View360 = 'view-360',
  Vk = 'vk',
  Warning = 'warning',
  WasherFluid = 'washer-fluid',
  Wechat = 'wechat',
  WelcomePackageDiscount = 'welcome-package-discount',
  WelcomePackage = 'welcome-package',
  Won_24 = 'won/24',
  WonSymbol_24 = 'won-symbol/24',
  Xing = 'xing',
  YenSymbol_24 = 'yen-symbol/24',
  Youtube = 'youtube',
  Zloty = 'zloty',
  ZoomInXs = 'zoom-in-xs',
  ZoomIn = 'zoom-in',
  ZoomIn2 = 'zoom-in2',
  ZoomOutXs = 'zoom-out-xs',
  ZoomOut = 'zoom-out',
  ZoomOut2 = 'zoom-out2',
}

export type IconName =
  | 'accident-management-xs'
  | 'accident-management'
  | 'add-opt'
  | 'alert-circle'
  | 'alert'
  | 'archive-xs'
  | 'archive'
  | 'arrow-back'
  | 'arrow-down-left/24'
  | 'arrow-down-right/24'
  | 'arrow-down'
  | 'arrow-forward'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up-left/24'
  | 'arrow-up-right/24'
  | 'arrow-up'
  | 'attach-driver'
  | 'attention'
  | 'authentication'
  | 'badge-eco'
  | 'badge-safety'
  | 'baht/24'
  | 'baht-symbol/24'
  | 'battery'
  | 'bds/1-5m-distance/16'
  | 'bds/1-5m-distance/24'
  | 'bds/accelerator/24'
  | 'bds/accessibility/24'
  | 'bds/accident-care/24'
  | 'bds/accident-management/24'
  | 'bds/ai/12'
  | 'bds/ai/16'
  | 'bds/ai/24'
  | 'bds/ai/32'
  | 'bds/arrow-back/16'
  | 'bds/arrow-back/24'
  | 'bds/arrow-down/16'
  | 'bds/arrow-down/24'
  | 'bds/arrow-download/16'
  | 'bds/arrow-download/24'
  | 'bds/arrow-forward/16'
  | 'bds/arrow-forward/24'
  | 'bds/arrow-left/24'
  | 'bds/arrow-right/24'
  | 'bds/arrow-up/16'
  | 'bds/arrow-up/24'
  | 'bds/backward-end/24'
  | 'bds/backward-end-2/24'
  | 'bds/badge-checkmark/24'
  | 'bds/badge-eco/24'
  | 'bds/battery/24'
  | 'bds/battery-capacity/24'
  | 'bds/battery-charging/24'
  | 'bds/battery-fill-high/24'
  | 'bds/battery-fill-low/24'
  | 'bds/battery-hybrid/24'
  | 'bds/battery-management/24'
  | 'bds/bookmark/16'
  | 'bds/bookmark/24'
  | 'bds/breaking-fluid/24'
  | 'bds/breaking-pad/24'
  | 'bds/buffer-loader/16'
  | 'bds/buffer-loader/24'
  | 'bds/build-up-depth-1/24'
  | 'bds/build-up-depth-2/24'
  | 'bds/build-up-height-1/24'
  | 'bds/build-up-height-2/24'
  | 'bds/build-up-weight-1/24'
  | 'bds/build-up-weight-2/24'
  | 'bds/build-up-width-1/24'
  | 'bds/build-up-width-2/24'
  | 'bds/business-case/24'
  | 'bds/calculator/16'
  | 'bds/calculator/24'
  | 'bds/calendar/24'
  | 'bds/call/24'
  | 'bds/call-sos/24'
  | 'bds/camera/24'
  | 'bds/car/16'
  | 'bds/car/24'
  | 'bds/car-compare/24'
  | 'bds/car-config/16'
  | 'bds/car-config/24'
  | 'bds/car-exchange/24'
  | 'bds/car-finder/24'
  | 'bds/car-new/16'
  | 'bds/car-new/24'
  | 'bds/car-open-top/24'
  | 'bds/car-save/24'
  | 'bds/caret-down/16'
  | 'bds/caret-down/24'
  | 'bds/caret-up-down/16'
  | 'bds/caret-up-down/24'
  | 'bds/center/24'
  | 'bds/charging/24'
  | 'bds/charging-ac/24'
  | 'bds/charging-dc/24'
  | 'bds/charging-time/24'
  | 'bds/chat/16'
  | 'bds/chat/24'
  | 'bds/checkmark/16'
  | 'bds/checkmark/24'
  | 'bds/checkmark-circle/16'
  | 'bds/checkmark-circle/24'
  | 'bds/chevron-down/16'
  | 'bds/chevron-down/24'
  | 'bds/chevron-horizontal/24'
  | 'bds/chevron-left/16'
  | 'bds/chevron-left/24'
  | 'bds/chevron-right/16'
  | 'bds/chevron-right/24'
  | 'bds/chevron-up/16'
  | 'bds/chevron-up/24'
  | 'bds/close/16'
  | 'bds/close/24'
  | 'bds/column-view-3/16'
  | 'bds/column-view-3/24'
  | 'bds/compass/24'
  | 'bds/content/16'
  | 'bds/content/24'
  | 'bds/cooling-fluid/16'
  | 'bds/cooling-fluid/24'
  | 'bds/disc/16'
  | 'bds/disc/24'
  | 'bds/discount/24'
  | 'bds/document/24'
  | 'bds/download/16'
  | 'bds/download/24'
  | 'bds/download-print/24'
  | 'bds/drive-type/24'
  | 'bds/drive-type-all-wheel/24'
  | 'bds/drive-type-front-wheel/24'
  | 'bds/drive-type-rear-wheel/24'
  | 'bds/e-car/24'
  | 'bds/e-car-comp/24'
  | 'bds/eco-coach/24'
  | 'bds/eco-consumption/24'
  | 'bds/electric-consumption/24'
  | 'bds/engine/16'
  | 'bds/engine/24'
  | 'bds/equipment-line/24'
  | 'bds/exclamation-mark/16'
  | 'bds/exclamation-mark/24'
  | 'bds/exclamation-mark-circle/24'
  | 'bds/exclamation-mark-circle-outline/16'
  | 'bds/exclamation-mark-circle-outline/24'
  | 'bds/eye/16'
  | 'bds/eye/24'
  | 'bds/facebook/24'
  | 'bds/filter/24'
  | 'bds/finger/24'
  | 'bds/forward-end/24'
  | 'bds/forward-end-2/24'
  | 'bds/fuel/24'
  | 'bds/fuel-comp/24'
  | 'bds/fuel-e/24'
  | 'bds/fuel-e-comp/24'
  | 'bds/fullscreen/16'
  | 'bds/fullscreen/24'
  | 'bds/fullscreen-exit/16'
  | 'bds/fullscreen-exit/24'
  | 'bds/gear/16'
  | 'bds/gear/24'
  | 'bds/geofence-circle/16'
  | 'bds/geofence-circle/24'
  | 'bds/geofence-rectangle/16'
  | 'bds/geofence-rectangle/24'
  | 'bds/geofence-triangle/16'
  | 'bds/geofence-triangle/24'
  | 'bds/globe/16'
  | 'bds/globe/24'
  | 'bds/graph/24'
  | 'bds/grid-view-16/16'
  | 'bds/grid-view-16/24'
  | 'bds/grid-view-4/16'
  | 'bds/grid-view-4/24'
  | 'bds/grid-view-9/16'
  | 'bds/grid-view-9/24'
  | 'bds/home/16'
  | 'bds/home/24'
  | 'bds/hotspot-active/16'
  | 'bds/hotspot-active/24'
  | 'bds/hotspot-default/16'
  | 'bds/hotspot-default/24'
  | 'bds/image/16'
  | 'bds/image/24'
  | 'bds/induction-charging/24'
  | 'bds/info/16'
  | 'bds/info/24'
  | 'bds/info-circle/16'
  | 'bds/info-circle/24'
  | 'bds/info-circle-outline/24'
  | 'bds/info-file/24'
  | 'bds/inspection-hu/24'
  | 'bds/instagram/24'
  | 'bds/insurance/24'
  | 'bds/internet-in-van/24'
  | 'bds/kakaotalk/24'
  | 'bds/layers/16'
  | 'bds/layers/24'
  | 'bds/light/24'
  | 'bds/light-off/24'
  | 'bds/light-on/24'
  | 'bds/link/16'
  | 'bds/link/24'
  | 'bds/linkedin/24'
  | 'bds/list-view/16'
  | 'bds/list-view/24'
  | 'bds/live-traffic-car/24'
  | 'bds/live-traffic-van/24'
  | 'bds/location/16'
  | 'bds/location/24'
  | 'bds/location-dealer/16'
  | 'bds/location-dealer/24'
  | 'bds/location-destination/16'
  | 'bds/location-destination/24'
  | 'bds/location-favorite/16'
  | 'bds/location-favorite/24'
  | 'bds/location-pin/16'
  | 'bds/location-pin/24'
  | 'bds/lock-closed/16'
  | 'bds/lock-closed/24'
  | 'bds/lock-open/16'
  | 'bds/lock-open/24'
  | 'bds/login/16'
  | 'bds/login/24'
  | 'bds/logistics/24'
  | 'bds/logout/16'
  | 'bds/logout/24'
  | 'bds/mail/16'
  | 'bds/mail/24'
  | 'bds/map/24'
  | 'bds/map-refresh/24'
  | 'bds/mb-star/16'
  | 'bds/mb-star/24'
  | 'bds/media-play/16'
  | 'bds/media-play/24'
  | 'bds/menu/16'
  | 'bds/menu/24'
  | 'bds/message/16'
  | 'bds/message/24'
  | 'bds/messenger/24'
  | 'bds/mileage/24'
  | 'bds/minus/16'
  | 'bds/minus/24'
  | 'bds/mobile-view-360/24'
  | 'bds/monitor-drive-style/24'
  | 'bds/monitor-eco/24'
  | 'bds/monitor-statistics/24'
  | 'bds/more/16'
  | 'bds/more/24'
  | 'bds/music/24'
  | 'bds/navigation-fleet/24'
  | 'bds/no-camera/24'
  | 'bds/no-eye/16'
  | 'bds/no-eye/24'
  | 'bds/notification/16'
  | 'bds/notification/24'
  | 'bds/oil/24'
  | 'bds/open-new/16'
  | 'bds/open-new/24'
  | 'bds/paragraph/12'
  | 'bds/paragraph/16'
  | 'bds/paragraph/24'
  | 'bds/paragraph/32'
  | 'bds/passenger-transport/24'
  | 'bds/pause/16'
  | 'bds/pause/24'
  | 'bds/pencil/16'
  | 'bds/pencil/24'
  | 'bds/pencil-company/24'
  | 'bds/pencil-document/24'
  | 'bds/phone/24'
  | 'bds/pinch/24'
  | 'bds/plus/16'
  | 'bds/plus/24'
  | 'bds/price-dollar/24'
  | 'bds/price-euro/24'
  | 'bds/print/16'
  | 'bds/print/24'
  | 'bds/question-mark/16'
  | 'bds/question-mark/24'
  | 'bds/question-mark-circle/24'
  | 'bds/question-mark-circle-outline/24'
  | 'bds/range-eletric/24'
  | 'bds/range-extension/24'
  | 'bds/refresh/16'
  | 'bds/refresh/24'
  | 'bds/remote-control/24'
  | 'bds/reset/16'
  | 'bds/reset/24'
  | 'bds/return-vehicle/24'
  | 'bds/road/24'
  | 'bds/rotate-landscape/16'
  | 'bds/rotate-landscape/24'
  | 'bds/rotate-portrait/16'
  | 'bds/rotate-portrait/24'
  | 'bds/route/24'
  | 'bds/route-overview-settings/24'
  | 'bds/safety-lock/24'
  | 'bds/search/16'
  | 'bds/search/24'
  | 'bds/seat/24'
  | 'bds/seat-front/24'
  | 'bds/seat-sections/24'
  | 'bds/service/16'
  | 'bds/service/24'
  | 'bds/service-a/24'
  | 'bds/service-b/24'
  | 'bds/service-calendar/24'
  | 'bds/service-craft/24'
  | 'bds/service-local/24'
  | 'bds/shopping-cart/16'
  | 'bds/shopping-cart/24'
  | 'bds/shopping-cart-search/24'
  | 'bds/snowflake/16'
  | 'bds/snowflake/24'
  | 'bds/special-offer/24'
  | 'bds/star/16'
  | 'bds/star/24'
  | 'bds/statistics/24'
  | 'bds/stop/24'
  | 'bds/subsidy/24'
  | 'bds/switch-seat/24'
  | 'bds/test-drive/24'
  | 'bds/tik-tok/24'
  | 'bds/time/16'
  | 'bds/time/24'
  | 'bds/time-plus/24'
  | 'bds/tire-pressure/24'
  | 'bds/total-weight/24'
  | 'bds/tow-truck/24'
  | 'bds/transmission/24'
  | 'bds/trash/16'
  | 'bds/trash/24'
  | 'bds/twitter/24'
  | 'bds/two-finger/24'
  | 'bds/upload/24'
  | 'bds/user/16'
  | 'bds/user/24'
  | 'bds/user-group/24'
  | 'bds/user-minus/24'
  | 'bds/user-plus/24'
  | 'bds/user-profile/16'
  | 'bds/user-profile/24'
  | 'bds/user-profile-selection/24'
  | 'bds/van/24'
  | 'bds/van-cabin-type-1/24'
  | 'bds/van-cabin-type-2/24'
  | 'bds/van-checked/24'
  | 'bds/van-citan-mixto/24'
  | 'bds/van-citan-panel/24'
  | 'bds/van-citan-tourer/24'
  | 'bds/van-compare/24'
  | 'bds/van-configuration/24'
  | 'bds/van-drive-mode-1/24'
  | 'bds/van-drive-mode-2/24'
  | 'bds/van-dropside/24'
  | 'bds/van-dropside-crewcabin/24'
  | 'bds/van-electric/24'
  | 'bds/van-exchange/24'
  | 'bds/van-frontal/24'
  | 'bds/van-marco-polo/24'
  | 'bds/van-marco-polo-easy-up/24'
  | 'bds/van-model/24'
  | 'bds/van-open-top/24'
  | 'bds/van-pickup/24'
  | 'bds/van-rental/24'
  | 'bds/van-roof-type/24'
  | 'bds/van-sector-carpenter/24'
  | 'bds/van-sector-food/24'
  | 'bds/van-sector-glazier/24'
  | 'bds/van-sector-landscape/24'
  | 'bds/van-sector-painter/24'
  | 'bds/van-sector-plumbing/24'
  | 'bds/van-share/24'
  | 'bds/van-sprinter/24'
  | 'bds/van-sprinter-chassis/24'
  | 'bds/van-sprinter-chassis-crewcabine/24'
  | 'bds/van-sprinter-chassis-option/24'
  | 'bds/van-sprinter-mixto/24'
  | 'bds/van-sprinter-panel/24'
  | 'bds/van-toggle-build-up-1/24'
  | 'bds/van-toggle-build-up-2/24'
  | 'bds/van-toggle-build-up-3/24'
  | 'bds/van-toggle-build-up-4/24'
  | 'bds/van-toggle-build-up-5/24'
  | 'bds/van-toggle-build-up-7/24'
  | 'bds/van-transport/24'
  | 'bds/van-travel/24'
  | 'bds/van-uptime/24'
  | 'bds/van-vehicle-search/24'
  | 'bds/van-vito-mixto/24'
  | 'bds/van-vito-panel/24'
  | 'bds/van-vito-tourer/24'
  | 'bds/van-wheelbase-1/24'
  | 'bds/van-wheelbase-2/24'
  | 'bds/vehicle-search/24'
  | 'bds/view-360/16'
  | 'bds/view-360/24'
  | 'bds/volume-down/16'
  | 'bds/volume-down/24'
  | 'bds/volume-off/16'
  | 'bds/volume-off/24'
  | 'bds/volume-up/16'
  | 'bds/volume-up/24'
  | 'bds/wall-box/24'
  | 'bds/warning/16'
  | 'bds/warning/24'
  | 'bds/washer-fluid/24'
  | 'bds/whatsapp/24'
  | 'bds/wheel/24'
  | 'bds/wheelbarrow/24'
  | 'bds/wheelchair/24'
  | 'bds/wifi/16'
  | 'bds/wifi/24'
  | 'bds/wishlist/24'
  | 'bds/wishlist-outlined/24'
  | 'bds/x/24'
  | 'bds/youtube/24'
  | 'bds/zalo/24'
  | 'bds/zoom-in/16'
  | 'bds/zoom-in/24'
  | 'bds/zoom-out/16'
  | 'bds/zoom-out/24'
  | 'bookmark-xs'
  | 'bookmark'
  | 'breakdown-management-xs'
  | 'breakdown-management'
  | 'breaking-fluid'
  | 'breaking-pad'
  | 'brochures-xs'
  | 'brochures'
  | 'buffer-loader'
  | 'build-up-depth-1'
  | 'build-up-depth-2'
  | 'build-up-height-1'
  | 'build-up-height-2'
  | 'build-up-weight-1'
  | 'build-up-weight-2'
  | 'build-up-width-1'
  | 'build-up-width-2'
  | 'bus'
  | 'calculator'
  | 'calendar'
  | 'calender-xs'
  | 'call-sos'
  | 'call'
  | 'camera'
  | 'car-compare-xs'
  | 'car-compare'
  | 'car-config'
  | 'car-exchange'
  | 'car-new'
  | 'car-opentop-xs'
  | 'car-opentop'
  | 'car-save-xs'
  | 'car-save'
  | 'car-to-x'
  | 'car-xs'
  | 'car'
  | 'caret-down'
  | 'caret-down/16'
  | 'caret-down/24'
  | 'caret-up/16'
  | 'caret-up/24'
  | 'caret-up-and-down'
  | 'caret-up-and-down/16'
  | 'caret-up-and-down/24'
  | 'center'
  | 'cep-logistics'
  | 'change-vehicle'
  | 'chat-xs'
  | 'chat'
  | 'checkmark-circle'
  | 'checkmark-xs'
  | 'checkmark'
  | 'chevron-down'
  | 'chevron-down/16'
  | 'chevron-down/24'
  | 'chevron-left'
  | 'chevron-left/16'
  | 'chevron-left/24'
  | 'chevron-right'
  | 'chevron-right/16'
  | 'chevron-right/24'
  | 'chevron-up'
  | 'chevron-up/16'
  | 'chevron-up/24'
  | 'choose-vehicle'
  | 'close'
  | 'close/16'
  | 'close/24'
  | 'co2-label-a'
  | 'co2-label-aplus'
  | 'co2-label-b'
  | 'co2-label-c'
  | 'co2-label-d'
  | 'co2-label-e'
  | 'co2-label-f'
  | 'co2-label-g'
  | 'comment-xs'
  | 'comment'
  | 'company/24'
  | 'company-registration'
  | 'compass'
  | 'connected'
  | 'construction-industry'
  | 'consumption'
  | 'contact-xs'
  | 'contact'
  | 'content'
  | 'convertible'
  | 'cooling-fluid'
  | 'copy-clipboard/24'
  | 'copy'
  | 'coupe'
  | 'credit-card/16'
  | 'credit-card/24'
  | 'danish-krone/24'
  | 'data-interface-1'
  | 'data-interface-2'
  | 'data-interface'
  | 'dealer'
  | 'delete'
  | 'dettach-driver'
  | 'digital-records-1'
  | 'digital-records-2'
  | 'dollar-symbol/24'
  | 'download'
  | 'downloadprint-xs'
  | 'downloadprint'
  | 'drive-style-monitor'
  | 'drive-type-all-wheel'
  | 'drive-type-front-wheel'
  | 'drive-type-rear-wheel'
  | 'drive-type'
  | 'driving-style-analysis-1'
  | 'driving-style-analysis-2'
  | 'eco-coach'
  | 'eco-monitor'
  | 'edit-document'
  | 'edit-xs'
  | 'edit'
  | 'engine-xs'
  | 'engine'
  | 'equipment-xs'
  | 'equipment'
  | 'equipmentline-xs'
  | 'equipmentline'
  | 'euro'
  | 'extend-runtime'
  | 'eye'
  | 'facebook'
  | 'favorite'
  | 'filter'
  | 'finger'
  | 'fleet-communication-1'
  | 'fleet-communication-2'
  | 'fleet-management-1'
  | 'fleet-management-2'
  | 'fuel-bio/24'
  | 'fuel-comp'
  | 'fuel-e-comp'
  | 'fuel-e'
  | 'fuel-hybrid/24'
  | 'fuel-hydrogen/24'
  | 'fuel-xs'
  | 'fuel'
  | 'galleryview-1'
  | 'galleryview-2'
  | 'galleryview-3'
  | 'galleryview-4'
  | 'gear-xs'
  | 'gear'
  | 'geofence-circle'
  | 'geofence-polygon'
  | 'geofence-rectangle'
  | 'google'
  | 'hatchback'
  | 'home-xs'
  | 'home'
  | 'hotspot-active'
  | 'hotspot-default'
  | 'improved-navigation-1'
  | 'improved-navigation-2'
  | 'inspection-hu'
  | 'instagram'
  | 'insurance'
  | 'internet-in-car'
  | 'jobs'
  | 'knowledge-bank'
  | 'krona'
  | 'language-xs'
  | 'language'
  | 'layers'
  | 'light-off'
  | 'light-on'
  | 'light'
  | 'limited-mobility'
  | 'linkedin'
  | 'listview-xs'
  | 'listview'
  | 'live-traffic'
  | 'locate-me'
  | 'location-xs'
  | 'location'
  | 'lock-closed'
  | 'lock-open'
  | 'login-xs'
  | 'login'
  | 'logout-xs'
  | 'logout'
  | 'magnifier-in'
  | 'magnifier-out'
  | 'mail-open/16'
  | 'mail-open/24'
  | 'malaysian-ringgit/24'
  | 'map-update'
  | 'map'
  | 'mbos/air-condition/12'
  | 'mbos/air-condition/16'
  | 'mbos/air-condition/24'
  | 'mbos/air-condition/32'
  | 'mbos/alarm-bell-check/24'
  | 'mbos/api/24'
  | 'mbos/api-operation/24'
  | 'mbos/applications/24'
  | 'mbos/browser-page-hierarchy/24'
  | 'mbos/busy-inprogress/24'
  | 'mbos/busy-pause/24'
  | 'mbos/cloud/24'
  | 'mbos/coding-bundle/24'
  | 'mbos/connector-chademo/12'
  | 'mbos/connector-chademo/16'
  | 'mbos/connector-chademo/24'
  | 'mbos/connector-chademo/32'
  | 'mbos/connector-css-type1/12'
  | 'mbos/connector-css-type1/16'
  | 'mbos/connector-css-type1/24'
  | 'mbos/connector-css-type1/32'
  | 'mbos/connector-css-type2/12'
  | 'mbos/connector-css-type2/16'
  | 'mbos/connector-css-type2/24'
  | 'mbos/connector-css-type2/32'
  | 'mbos/connector-gb-t/12'
  | 'mbos/connector-gb-t/16'
  | 'mbos/connector-gb-t/24'
  | 'mbos/connector-gb-t/32'
  | 'mbos/connector-type1/12'
  | 'mbos/connector-type1/16'
  | 'mbos/connector-type1/24'
  | 'mbos/connector-type1/32'
  | 'mbos/connector-type2/12'
  | 'mbos/connector-type2/16'
  | 'mbos/connector-type2/24'
  | 'mbos/connector-type2/32'
  | 'mbos/connector-type3/12'
  | 'mbos/connector-type3/16'
  | 'mbos/connector-type3/24'
  | 'mbos/connector-type3/32'
  | 'mbos/container-registry/24'
  | 'mbos/copy/24'
  | 'mbos/create-initial-version/24'
  | 'mbos/device-cluster/24'
  | 'mbos/disabled/24'
  | 'mbos/enabled/24'
  | 'mbos/file-code/24'
  | 'mbos/file-code-dowload/24'
  | 'mbos/file-code-download/24'
  | 'mbos/flash/24'
  | 'mbos/fleets/24'
  | 'mbos/hard-drive/24'
  | 'mbos/hierarchy-1/24'
  | 'mbos/hierarchy-2/24'
  | 'mbos/hierarchy-3/24'
  | 'mbos/home-charging/12'
  | 'mbos/home-charging/16'
  | 'mbos/home-charging/24'
  | 'mbos/home-charging/32'
  | 'mbos/installation-pending/24'
  | 'mbos/installation-queued/24'
  | 'mbos/installation-skipped/24'
  | 'mbos/item-added/24'
  | 'mbos/item-removed/24'
  | 'mbos/laptop/24'
  | 'mbos/mdx-cli/24'
  | 'mbos/microchip-board/24'
  | 'mbos/network-settings/24'
  | 'mbos/office-charging/12'
  | 'mbos/office-charging/16'
  | 'mbos/office-charging/24'
  | 'mbos/office-charging/32'
  | 'mbos/offline/24'
  | 'mbos/offline-paused/24'
  | 'mbos/online/24'
  | 'mbos/online-paused/24'
  | 'mbos/package-car/24'
  | 'mbos/package-domain/24'
  | 'mbos/package-ecu/24'
  | 'mbos/package-generic/24'
  | 'mbos/package-revision/24'
  | 'mbos/package-system/24'
  | 'mbos/package-variant/24'
  | 'mbos/packages/24'
  | 'mbos/permission-denied/24'
  | 'mbos/plug-and-charge-logo/12'
  | 'mbos/plug-and-charge-logo/16'
  | 'mbos/plug-and-charge-logo/24'
  | 'mbos/plug-and-charge-logo/32'
  | 'mbos/queued/24'
  | 'mbos/ready-to-pickup/24'
  | 'mbos/shipment-next/24'
  | 'mbos/shipment-online-monitor/24'
  | 'mbos/status/24'
  | 'mbos/status-small/24'
  | 'mbos/testing/24'
  | 'mbos/unknown/24'
  | 'mbos/variant-coding/24'
  | 'mbos/variant-coding-tool/24'
  | 'media-back-xs'
  | 'media-back'
  | 'media-forward-xs'
  | 'media-forward'
  | 'media-pause-xs'
  | 'media-pause'
  | 'media-play/16'
  | 'media-pause/24'
  | 'media-stop'
  | 'media-to-end-xs'
  | 'media-to-end'
  | 'media-to-start-xs'
  | 'media-to-start'
  | 'menu-xs'
  | 'menu'
  | 'mercedes-benz-myvan'
  | 'mileage-digital'
  | 'mileage-xs'
  | 'mileage'
  | 'minus'
  | 'minus/16'
  | 'minus/24'
  | 'mobile-view-360'
  | 'modelfinder'
  | 'modeltype'
  | 'more'
  | 'multimedia-navigation'
  | 'multiply-user-xs'
  | 'multiply-user'
  | 'music-xs'
  | 'music'
  | 'navigation-coach'
  | 'navigation-fleet'
  | 'navigation-monitor'
  | 'no-camera'
  | 'no-eye'
  | 'notification'
  | 'offroader'
  | 'oil'
  | 'optimized-assistance-1'
  | 'optimized-assistance-2'
  | 'passenger-transport'
  | 'pause/16'
  | 'pause/24'
  | 'pin-general'
  | 'pinch'
  | 'pinterest'
  | 'pencil/16'
  | 'pencil/24'
  | 'play'
  | 'plus'
  | 'poi-favorite'
  | 'pound'
  | 'print-xs'
  | 'print'
  | 'privacy'
  | 'productfinder'
  | 'question-mark-circle'
  | 'question-mark-outline'
  | 'rand/24'
  | 'refrigerated'
  | 'reload-xs'
  | 'reload'
  | 'remote-control'
  | 'reset-zoom'
  | 'return-vehicle'
  | 'roadster'
  | 'rotate-landscape'
  | 'rotate-portrait'
  | 'rupee/24'
  | 'rupee-symbol/24'
  | 'russian-ruble-1/24'
  | 'russian-ruble-2/24'
  | 'russian-ruble-symbol/24'
  | 'russian-ruble'
  | 'safety-coach'
  | 'safety-events'
  | 'safety-trophy-eco'
  | 'safety-trophy'
  | 'save-xs'
  | 'save'
  | 'screen-max'
  | 'screen-min'
  | 'scrollindicator'
  | 'search-xs'
  | 'search'
  | 'seat-van'
  | 'seat-xs'
  | 'seat'
  | 'sedan'
  | 'send2car'
  | 'service-a'
  | 'service-appointment'
  | 'service-b'
  | 'service-car'
  | 'service-craft'
  | 'service-local'
  | 'service'
  | 'settings'
  | 'share-xs'
  | 'share'
  | 'shootingbrake'
  | 'shopping-xs'
  | 'shopping'
  | 'smart'
  | 'software-update'
  | 'sound-max'
  | 'sound-min'
  | 'sound-off-xs'
  | 'sound-off'
  | 'sportstourer'
  | 'statistics'
  | 'swedish-krona/24'
  | 'swiss-franc/24'
  | 't-model'
  | 'tag/16'
  | 'tag/24'
  | 'take-me-to-vehicle'
  | 'testdrive-xs'
  | 'testdrive'
  | 'theft-warning'
  | 'time-xs'
  | 'time'
  | 'tire-pressure'
  | 'trend-down'
  | 'trend-neutral'
  | 'trend-up'
  | 'trip-business'
  | 'trip-end'
  | 'trip-route-driverslog'
  | 'trip-route-managment'
  | 'trip-route'
  | 'trip-start'
  | 'trip-type'
  | 'truck'
  | 'turkish-lira/24'
  | 'twitter'
  | 'two-finger'
  | 'unimog'
  | 'upload-xs'
  | 'upload'
  | 'used-vehicle-search'
  | 'user'
  | 'userimage'
  | 'van-add'
  | 'van-cabin-type-1'
  | 'van-cabin-type-2'
  | 'van-citan-mixto'
  | 'van-citan-panel'
  | 'van-citan-tourer'
  | 'van-compare'
  | 'van-configuration'
  | 'van-drive-mode-1'
  | 'van-drive-mode-2'
  | 'van-dropside-crewcabine'
  | 'van-dropside'
  | 'van-frontal'
  | 'van-maintenance'
  | 'van-marco-polo-easy-up'
  | 'van-marco-polo'
  | 'van-model'
  | 'van-open-top'
  | 'van-pickup'
  | 'van-rental'
  | 'van-roof-type'
  | 'van-sprinter-chassis-crewcabine'
  | 'van-sprinter-chassis-option-detail'
  | 'van-sprinter-chassis-option'
  | 'van-sprinter-chassis'
  | 'van-sprinter-mixto'
  | 'van-sprinter-panel'
  | 'van-sprinter'
  | 'van-toggle-build-up-1'
  | 'van-toggle-build-up-2'
  | 'van-toggle-build-up-3'
  | 'van-toggle-build-up-4'
  | 'van-toggle-build-up-5'
  | 'van-toggle-build-up-6'
  | 'van-toggle-build-up-7'
  | 'van-toggle-build-up-xs-1'
  | 'van-toggle-build-up-xs-2'
  | 'van-toggle-build-up-xs-3'
  | 'van-toggle-build-up-xs-4'
  | 'van-toggle-build-up-xs-5'
  | 'van-toggle-build-up-xs-6'
  | 'van-total-weight'
  | 'van-transport'
  | 'van-travel'
  | 'van-vito-mixto'
  | 'van-vito-panel'
  | 'van-vito-tourer'
  | 'van-wheelbase-1'
  | 'van-wheelbase-2'
  | 'van'
  | 'van2share'
  | 'vehicle-control-1'
  | 'vehicle-control-2'
  | 'vehicle-managment-tool'
  | 'vehicle-operations'
  | 'vehicle-panel'
  | 'vehicle-supervision'
  | 'vehiclesearch'
  | 'video-xs'
  | 'video'
  | 'view-360'
  | 'vk'
  | 'warning'
  | 'washer-fluid'
  | 'wechat'
  | 'welcome-package-discount'
  | 'welcome-package'
  | 'won/24'
  | 'won-symbol/24'
  | 'xing'
  | 'yen-symbol/24'
  | 'youtube'
  | 'zloty'
  | 'zoom-in-xs'
  | 'zoom-in'
  | 'zoom-in2'
  | 'zoom-out-xs'
  | 'zoom-out'
  | 'zoom-out2';
